var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { faEdit, faSitemap, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BButtonGroup } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { RouterLink } from "vue-router";
import { useRouter } from "vue-router/composables";
import { isRegisteredUser } from "@/api";
import { useWorkflowInstance } from "@/composables/useWorkflowInstance";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import { errorMessageAsString } from "@/utils/simple-error";
import { copyWorkflow } from "./workflows.services";
import AsyncButton from "../Common/AsyncButton.vue";
import ButtonSpinner from "../Common/ButtonSpinner.vue";
import WorkflowRunButton from "./WorkflowRunButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowNavigationTitle',
    props: {
        invocation: { default: undefined },
        workflowId: null,
        runDisabled: { type: Boolean },
        runWaiting: { type: Boolean },
        success: { type: Boolean }
    },
    emits: ["on-execute"],
    setup(__props, { emit }) {
        const props = __props;
        const router = useRouter();
        const { workflow, error } = useWorkflowInstance(props.workflowId);
        const { currentUser, isAnonymous } = storeToRefs(useUserStore());
        const owned = computed(() => {
            if (isRegisteredUser(currentUser.value) && workflow.value) {
                return currentUser.value.username === workflow.value.owner;
            }
            else {
                return false;
            }
        });
        const importErrorMessage = ref(null);
        const importedWorkflow = ref(null);
        const workflowImportedAttempted = ref(false);
        function onImport() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!workflow.value || !workflow.value.owner) {
                    return;
                }
                try {
                    const wf = yield copyWorkflow(workflow.value.id, workflow.value.owner);
                    importedWorkflow.value = wf;
                }
                catch (error) {
                    importErrorMessage.value = errorMessageAsString(error, "Failed to import workflow");
                }
                finally {
                    workflowImportedAttempted.value = true;
                }
            });
        }
        function getWorkflowName() {
            var _a;
            return ((_a = workflow.value) === null || _a === void 0 ? void 0 : _a.name) || "...";
        }
        const workflowImportTitle = computed(() => {
            if (isAnonymous.value) {
                return localize("Login to import this workflow");
            }
            else if (workflowImportedAttempted.value) {
                return localize("Workflow imported");
            }
            else {
                return localize("Import this workflow");
            }
        });
        return { __sfc: true, router, props, emit, workflow, error, currentUser, isAnonymous, owned, importErrorMessage, importedWorkflow, workflowImportedAttempted, onImport, getWorkflowName, workflowImportTitle, faEdit, faSitemap, faUpload, FontAwesomeIcon, BAlert, BButton, BButtonGroup, RouterLink, AsyncButton, ButtonSpinner, WorkflowRunButton };
    }
});
